import React from 'react';
import DownloadButton from '../input/DownloadButton';
import TableEditor from '../TableEditor';
import exportMapper from '../mapping/exportMapper';

export default ({ rows, errorMessage, updateResearchActivity, updateHealthCategory, back, lastSaved }) => {
    return <div className="HrcsEditor">
        {errorMessage ? <div className="error">{errorMessage}</div> : ''}
        <Menu back={back} rows={rows} exportMapper={exportMapper} lastSaved={lastSaved} />
        <TableEditor
            rows={ rows }
            updateResearchActivity={updateResearchActivity}
            updateHealthCategory={updateHealthCategory}
        />
        <Menu back={back} rows={rows} exportMapper={exportMapper} lastSaved={lastSaved} />
    </div>
}

function Menu({back, rows, exportMapper, lastSaved}) {
    return (
        <div className="HrcsEditor-menu">
            <button onClick={back}>Tilbake</button>
            <DownloadButton data={ () => exportMapper(rows) } />
            <div>Sist lagret lokalt kl. <span>{lastSaved}</span></div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/steps/EditStep.js